module.exports = __webpack_public_path__ + "img/APPR.06eafca3.svg";